import { ThemeKey } from "@smartsheet/design-tokens";

/**
 * A function that creates theme classes from a valid theme key. Useful for adding necessary theme classes to any element, namely the inner theme provider div.
 * @param themeKey a valid theme key name string
 * @returns a single string that contains each class necessary for the chosen theme
 */
export const getThemeClasses = (themeKey: ThemeKey) => {
    let classes = "";
    if (themeKey?.includes("ursa")) {
        classes += "ursa";
    } else {
        classes += "lodestar";
    }
    classes += ` ${themeKey}`;

    return classes;
};
